export default {
  tabs: {
    home: "Home",
    browse: "Esplora",
    trends: "Trend",
    myPicks: "Le mie scelte",
    leagues: "Leghe",
  },
  common: {
    viewAll: "Vedi tutto",
    operator: "Operatore",
    priceComparison: "Confronto quote",
    linematePlus: "Linemate+",
    joinLinematePlus: "Iscriviti a Linemate+",
    actions: {
      apply: "Applica",
      clearAll: "Cancella tutto",
      gotIt: "Ho capito",
      cancel: "Annulla",
      close: "Chiudi",
      openSettings: "Apri impostazioni",
      continue: "Continua",
      claim: "Riscatta",
      visitPartner: "Visita partner",
      alreadyHaveAccount: "Ho già un account",
      edit: "Modifica",
      done: "Fatto",
      save: "Salva",
      changePassword: "Cambia password",
      submit: "Invia",
      resendCode: "Reinvia codice",
      getStarted: "Inizia",
      continueWithApple: "Continua con Apple",
      continueWithGoogle: "Continua con Google",
      continueWithEmail: "Continua con email",
      selectLocation: "Seleziona una località",
      showMore: "Mostra altro",
    },
    labels: {
      player: "Giocatore",
      team: "Squadra",
      firstName: "Nome",
      lastName: "Cognome",
      username: "Nome utente",
      email: "Email",
      password: "Password",
      emailAddress: "Indirizzo email",
      confirmPassword: "Conferma password",
      code: "Codice",
      preferredOdds: "Quote preferite",
    },
    placeholders: {
      emailAddress: "Inserisci il tuo indirizzo email...",
      password: "Inserisci la password...",
    },
    errors: {
      genericTryAgainLater: "Qualcosa è andato storto, riprova più tardi.",
      noInternetConnection: "Nessuna connessione Internet",
    },
    search: {
      teamOrPlayerPlaceholder: "Cerca una squadra o un giocatore...",
    },
    affiliate: {
      claimYourOffer: "Riscatta la tua offerta {{operator}}",
    },
    advancedTools: {
      startingLineups: "Formazioni iniziali",
      startingPitchers: "Lanciatori partenti",
      weatherReport: "Meteo",
    },
    toasts: {
      addedToMyPicks: "Aggiunto a Le mie scelte",
      alreadyInMyPicks: "Già in Le mie scelte",
    },
    hints: {
      goToMyPicks: "Vai a Le mie scelte per piazzare la scommessa.",
    },
    profile: {
      completeYourProfile: "Completa il tuo profilo",
    },
    bonuses: "Bonus",
    statHeaders: {
      "+/-": "+/-",
      "1B": "1B",
      "1D": "1D",
      "1PT": "1PT",
      "20/40": "20/40",
      "2B": "2B",
      "2PT": "2PT",
      "2YELRED": "2YELRED",
      "3B": "3B",
      "3D%": "3D%",
      "3PT%": "3PT%",
      "3PTA": "3PTA",
      "3PTM": "3PTM",
      "4D%": "4D%",
      "40/20": "40/20",
      "A": "A",
      "AB": "AB",
      "AST": "AST",
      "AVG": "AVG",
      "B": "B",
      "BB": "BB",
      "BK": "BK",
      "BLK": "BLK",
      "C%": "C%",
      "CA": "CA",
      "CF%": "CF%",
      "CFK": "CFK",
      "CM": "CM",
      "COR": "COR",
      "CR%": "CR%",
      "CS": "CS",
      "D": "D",
      "DHR": "DHR",
      "DP": "DP",
      "DR": "DR",
      "DRI": "DRI",
      "DSAV": "DSAV",
      "EFG%": "eFG%",
      "ER": "ER",
      "ERA": "ERA",
      "FG": "FG",
      "FG%": "FG%",
      "FGA": "FGA",
      "FGM": "FGM",
      "FLS": "FLS",
      "FT%": "FT%",
      "FTA": "FTA",
      "FTM": "FTM",
      "FUML": "FUML",
      "G": "G",
      "GA": "GS",
      "GK": "GK",
      "GP": "PG",
      "OPP": "AVV",
      "H": "H",
      "HO": "HO",
      "HR": "HR",
      "HU": "HU",
      "INT": "INT",
      "ISO": "ISO",
      "IS": "IS",
      "K": "K",
      "KM": "KM",
      "KR": "KR",
      "KRM": "KRM",
      "L": "S",
      "LB": "LB",
      "LOP": "LOP",
      "M": "M",
      "MI50": "MI50",
      "MIN": "MIN",
      "OBP": "OBP",
      "OFF": "OFF",
      "OPS": "OPS",
      "P": "P",
      "PAS": "PAS",
      "PASS ATT": "PASS ATT",
      "PASS COMP": "PASS COMP",
      "PASS RTG": "PASS RTG",
      "PASS TD": "PASS TD",
      "PASS YDS": "PASS YDS",
      "PASS YDS/ATT": "PASS YDS/ATT",
      "PASS RZ ATT": "PASS RZ ATT",
      "PASS RZ COMPL": "PASS RZ COMPL",
      "PASS RZ TD": "PASS RZ TD",
      "PCRM": "PCRM",
      "PIM": "PIM",
      "PLAYS": "PLAYS",
      "POS": "POS",
      "POS%": "POS%",
      "PP%": "PP%",
      "PPG": "PPG",
      "PPP": "PPP",
      "PS": "PS",
      "PTS": "PTS",
      "R": "R",
      "RBI": "RBI",
      "REB": "REB",
      "REC": "REC",
      "REC TGT": "REC TGT",
      "REC TD": "REC TD",
      "REC YDS": "REC YDS",
      "REC YDS/REC": "REC YDS/REC",
      "REC 100+ YDS": "REC 100+ YDS",
      "REC RZ TGT": "REC RZ TGT",
      "REC RZ REC": "REC RZ REC",
      "REC RZ TD": "REC RZ TD",
      "RED": "CR",
      "RM": "RM",
      "RUSH ATT": "RUSH ATT",
      "RUSH LONG": "RUSH LONG",
      "RUSH TD": "RUSH TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH YDS/ATT": "RUSH YDS/ATT",
      "RUSH 100+ YDS": "RUSH 100+ YDS",
      "RUSH RZ ATT": "RUSH RZ ATT",
      "RUSH RZ TD": "RUSH RZ TD",
      "RZ%": "RZ%",
      "S": "S",
      "S%": "S%",
      "SA": "SA",
      "SAT": "SAT",
      "SAV": "SAV",
      "SAVES": "SAVES",
      "SHG": "SHG",
      "SH%": "SH%",
      "SHO": "SHO",
      "SHP": "SHP",
      "SHUTOUTS": "SHUTOUTS",
      "SK": "SK",
      "SLG": "SLG",
      "SO": "SO",
      "SOG": "SOG",
      "SOT": "SOT",
      "STL": "STL",
      "SV": "SV",
      "SV%": "SV%",
      "T": "T",
      "TA": "TA",
      "TB": "TB",
      "TCK": "TCK",
      "TD": "TD",
      "TO": "TO",
      "TOI": "TOI",
      "TRB": "REB",
      "TS%": "TS%",
      "USAGE %": "USAGE %",
      "W": "V",
      "WHIP": "WHIP",
      "WINS": "V",
      "XPA": "XPA",
      "XPM": "XPM",
      "XP%": "XP%",
      "YDS": "YDS",
      "YEL": "CG",
      "FG (0-19)": "FG (0-19)",
      "FG (20-29)": "FG (20-29)",
      "FG (30-39)": "FG (30-39)",
      "FG (40-49)": "FG (40-49)",
      "FG (50+)": "FG (50+)",
      "300+ YDS": "300+ YDS",
    },
    sportStatHeaders: {
      "soccer": {
        "team": {
          "Running performance (per match)": "Prestazioni di corsa (per partita)",
          "Distance covered": "Distanza coperta",
          "Number of sprints": "Numero di sprint",
          "Attacking": "Attacco",
          "Goals per game": "Goal a partita",
          "Penalty goals": "Gol su rigore",
          "Free kick goals": "Gol su punizione",
          "Goals from inside the box": "Gol da dentro l'area di rigore",
          "Goals from outside the box": "Gol da fuori area",
          "Left-footed goals": "Gol segnati di sinistro",
          "Right-footed goals": "Gol segnati di destro",
          "Headed goals": "Goal di testa",
          "Big chances per game": "Grandi occasioni a partita",
          "Big chances missed per game": "Grandi occasioni mancate a partita",
          "Total shots per game": "Totale tiri a partita",
          "Shots on target per game": "Tiri in porta a partita",
          "Shots off target per game": "Tiri fuori a partita",
          "Blocked shots per game": "Tiri respinti per partita",
          "Succ. dribbles per game": "Dribbling riusciti a partita",
          "Corners per game": "Calci d'angolo a partita",
          "Free kicks per game": "Calci di punizione a partita",
          "Hit woodwork": "Pali e traverse",
          "Counter attacks": "Contropiedi",
          "Passes": "Passaggi",
          "Ball possession": "Possesso palla",
          "Accurate passes": "Passaggi precisi",
          "Acc. own half": "Precisione passaggi nella propria metà campo",
          "Acc. opposition half": "Precisione passaggi nella metà campo avversaria",
          "Acc. long balls": "Palle lunghe precise",
          "Acc. crosses": "Acc. dei cross",
          "Defending": "Difesa",
          "Clean sheets": "Porta inviolata",
          "Goals conceded per game": "Gol subiti a partita",
          "Tackles per game": "Contrasti a partita",
          "Interceptions per game": "Intercetti a partita",
          "Clearances per game": "Salvataggi sulla linea per partita",
          "Saves per game": "Parate a partita",
          "Balls recovered per game": "Palle recuperate a partita",
          "Errors leading to shot": "Errori che hanno portato al tiro",
          "Errors leading to goal": "Errori che hanno portato al gol",
          "Penalties committed": "Rigori commessi",
          "Penalty goals conceded": "Rigori realizzati",
          "Clearance off line": "Salvataggio sulla linea",
          "Last man tackle": "Fallo su ultimo uomo",
          "Other": "Altro",
          "Duels won per game": "Contrasti vinti a partita",
          "Ground duels won": "Duelli a terra vinti",
          "Aerial duels won": "Contrasti aerei vinti",
          "Possession lost per game": "Possesso perso a partita",
          "Throw-ins per game": "Rimesse laterali a partita",
          "Goal kicks per game": "Rimesse dal fondo a partita",
          "Offsides per game": "Fuorigioco a partita",
          "Fouls per game": "Falli a partita",
          "Yellow cards per game": "Ammonizioni a partita",
          "Red cards": "Cartellini rossi"
        },
        "player": {
          "Matches": "Partite",
          "Appearances": "Presenze",
          "Started": "Titolare",
          "Minutes per game": "Minuti a partita",
          "Total minutes played": "Totale dei minuti giocati",
          "Team of the week": "Squadra della settimana",
          "Running performance (per 90)": "Prestazioni di corsa (per 90)",
          "Top speed": "Velocità massima",
          "Goals": "Gol",
          "Expected goals (xG)": "Goal attesi (xG)",
          "Scoring frequency (in minutes)": "Frequenza gol (in minuti)",
          "Total shots": "Tiri totali",
          "Shots on target per game": "Shots on target per game",
          "Big chances missed": "Grandi occasioni da rete mancate",
          "Goal conversion": "Percentuale realizzativa",
          "Penalty conversion": "Conversione rigori",
          "Free kick conversion": "Conversione dei calci di punizione",
          "Penalty won": "Rigori conquistati",
          "Passing": "Passaggio",
          "Assists": "Assists",
          "Expected assists (xA)": "Assist previsti (xA)",
          "Touches": "Tocchi",
          "Big chances created": "Grandi occasioni create",
          "Key passes": "Passaggi chiave",
          "Long balls (accurate)": "Lanci lunghi (prec.)",
          "Accurate chip passes": "Precisione passaggi pallonetto",
          "Interceptions": "Intercetti",
          "Possession won (final third)": "Palle recuperate (terzo offensivo)",
          "Dribbled past per game": "Dribbling subiti per partita",
          "Other (per game)": "Altro (a partita)",
          "Succ. dribbles": "Dribbling riusciti",
          "Total duels won": "Totale contrasti vinti",
          "Possession lost": "Palla persa",
          "Was fouled": "Falli subiti",
          "Offsides": "Fuorigioco",
          "Cards": "Cartellini",
          "Yellow": "Ammonizione",
          "Red (2 yellows)": "Rosso (2 gialli)",
          "Red": "Rosso"
        }
      },
      "hockey": {
        "team": {
          "Game overview": "Panoramica partita",
          "Shots on goal": "Tiri in porta",
          "Penalties": "Penalità",
          "Penalty minutes": "Minuti di penalità",
          "Hits": "Contrasti",
          "Blocked shots": "Tiri bloccati",
          "Takeaways": "Dischi recuperati",
          "Giveaways": "Dischi persi",
          "Empty net goals": "Gol a porta vuota",
          "Power play %": "Superiorità %",
          "Faceoffs won": "Ingaggi vinti",
          "Game Shotmap": "Mappa dei tiri della partita",
          "Select shot type in shotmap": "Select shot type in shotmap",
          "Special teams": "Situazioni speciali",
          "Power play shot %": "Tiri in superiorità %",
          "Shorthanded shot %": "Tiri in inferiorità %",
          "Even strength shot %": "Tiri in parità numerica %",
          "Power play faceoffs": "Ingaggi in superiorità",
          "Shorthanded faceoffs": "Ingaggi in inferiorità",
          "Even strength faceoffs": "Ingaggi in parità numerica",
          "5v4 conversion": "Tasso di conversione 5v4",
          "Shots": "Tiri",
          "Wrist": "Polso",
          "Slap": "Slap",
          "Backhand": "Rovescio",
          "Tip": "Tip",
          "Snap": "Snap",
          "Advanced stats": "Statistiche avanzate",
          "Corsi %": "Corsi %",
          "Fenwick %": "Fenwick %",
          "Average shot distance": "Distanza media dei tiri"
        },
        "player": {
          "Overall": "Generale",
          "Games played": "Partite giocate",
          "Average time on ice": "Tempo sul ghiaccio in parità numerica",
          "Goals": "Gol",
          "Assists": "Assists",
          "Points": "Punti",
          "Plus/minus": "Plus/minus",
          "Shots on goal": "Tiri in porta",
          "Shooting percentage": "Percentuale al tiro",
          "Game winning goals": "Gol della vittoria",
          "Overtime goals": "Gol nei supplementari",
          "Defensive": "Difensivi",
          "Penalty minutes": "Minuti di penalità",
          "Blocked shots": "Tiri bloccati",
          "Hits": "Contrasti",
          "Power play": "Gioco in superiorità",
          "Powerplay average time on ice": "Tempo medio sul ghiaccio in superiorità",
          "Power play goals": "Goal in superiorità",
          "Power play assists": "Assist in superiorità",
          "Power play points": "Punti in superiorità",
          "Shorthanded": "Inferiorità",
          "Shorthanded average time on ice": "Tempo medio sul ghiaccio in inferiorità",
          "Shorthanded goals": "Gol in inferiorità",
          "Shorthanded assists": "Assist in inferiorità",
          "Shorthanded points": "Punti in inferiorità",
          "Shorthanded shots": "Tiri in inferiorità",
          "Even-strength": "Parità numerica",
          "Even strength average time on ice": "Tempo medio sul ghiaccio a parità numerica",
          "Faceoff": "Ingaggio",
          "Faceoffs taken": "Ingaggi fatti",
          "Faceoffs won": "Ingaggi vinti",
          "Faceoff win percentage": "Percentuale di faceoff vinti"
        }
      },
      "baseball": {
        "AB": "At-bat",
        "R": "Punti",
        "H": "Battute valide",
        "RBI": "Punti battuti a casa",
        "HR": "Home run",
        "BB": "Walk",
        "K": "Strikeout",
        "AVG": "Media battuta",
        "OBP": "Percentuale in base",
        "SLG": "Percentuale slugging",
        "OPS": "Percentuale in base e slugging",
        "IP": "Inning lanciati",
        "ERA": "Media PGL",
        "H_ALLOWED": "Valide concesse",
        "R_ALLOWED": "Punti concessi",
        "ER": "Punti guadagnati",
        "BB_ALLOWED": "Walk concessi",
        "HR_ALLOWED": "Home run concessi",
        "NP": "Numero di lanci",
        "STR": "Strike lanciati",
        "WHIP": "Walk e battute per inning lanciato",
        "PO": "Putout",
        "A": "Assists",
        "E": "Errori",
        "DP": "Doppi giochi",
        "CS": "Eliminato in rubata",
        "SB": "Basi rubate concesse"
      },
      "basketball": {
        "team": {
          "Free throws": "Tiri liberi",
          "2 pointers": "Canestri da 2 punti",
          "3 pointers": "Canestri da 3 punti",
          "Field goals": "Tiri dal campo",
          "Rebounds": "Rimbalzi",
          "Defensive rebounds": "Rimbalzi difensivi",
          "Offensive rebounds": "Rimbalzi offensivi",
          "Assists": "Assists",
          "Turnovers": "Palle perse",
          "Steals": "Rubate",
          "Blocks": "Stoppate",
          "Fouls": "Falli",
          "Max points in a row": "Massimo di punti consecutivi",
          "Time spent in lead": "Tempo in vantaggio",
          "Biggest lead": "Massimo vantaggio"
        },
        "player": {
          "MIN": "Minuti giocati",
          "PTS": "Punti",
          "REB": "Rimbalzi",
          "AST": "Assists",
          "STL": "Rubate",
          "BLK": "Stoppate",
          "PF": "Falli personali",
          "TOV": "Palle perse",
          "OREB": "Rimbalzi offensivi",
          "DREB": "Rimbalzi difensivi",
          "FG": "Tiri dal campo",
          "FG%": "% di tiri segnati",
          "FT": "Tiri liberi",
          "FT%": "% tiri liberi",
          "3P": "Canestri da 3 punti",
          "3P%": "Percentuale tiri da 3 punti",
          "+/-": "Plus-Minus",
          "PIR": "Valutazione dell'indice di prestazione"
        }
      },
      "americanFootball": {
        "team": {
          "Offense": "Attacco",
          "TD": "Touchdown",
          "FG": "Field goal",
          "NET YDS": "Yard totali",
          "TO": "Palle perse",
          "RZ%": "Efficienza nella red zone",
          "1D": "Primi down",
          "3D%": "Efficenza terzi down",
          "Passing": "Passaggio",
          "PASS YDS": "Net passing yards",
          "PASS TD": "Touchdowns da lancio",
          "INT THROWN": "Intercetti lanciati",
          "PASS YDS/ATT": "Yard medie per tentativo di passaggio",
          "PASS RZ ATT": "Tentativi di passaggio nella Red zone",
          "Rushing": "Attacchi",
          "RUSH ATT": "Tentativi di corsa",
          "RUSH YDS": "Yard percorse correndo",
          "RUSH YDS/ATT": "Yard medie per tentativo di corsa",
          "Rushing 1st downs": "Corsa ai primi down",
          "RUSH RZ ATT": "Tentativi di corsa nella Red zone",
          "Other": "Altro",
          "FUML": "Fumbles persi"
        },
        "player": {
          "PASS COMP": "Tentativi di passaggio completati",
          "PASS ATT": "Tentativi",
          "PASS YDS": "Yard ottenute da lancio",
          "PASS TD": "Touchdowns da lancio",
          "INT": "Passaggi intercettati",
          "PASS YDS/ATT": "Yard passate per tentativo",
          "PASS RTG": "Passer rating",
          "RUSH ATT": "Tentativi di corsa",
          "RUSH YDS": "Yard percorse correndo",
          "RUSH TD": "Touchdowns da corsa",
          "RUSH YDS/ATT": "Yard su corsa per tentativo",
          "RUSH LONG": "Corsa più lunga",
          "REC TGT": "Receiving targets",
          "REC": "Ricezioni",
          "REC YDS": "Yards ottenute da ricevitore del passaggio",
          "REC TD": "Touchdowns dopo lancio",
          "REC YDS/REC": "Yard per ricezione",
          "TCK": "Placcaggi combinati",
          "SK": "Numero di sack",
          "FUML": "Fumbles persi",
          "FGM": "Field goal realizzati",
          "XPM": "Punti extra realizzati",
          "PTS": "Punti totali"
        }
      },
      "rugby": {
        "team": {
          "Ball possession": "Possesso palla",
          "Passes": "Passaggi",
          "Tries": "Mete",
          "Try assists": "Tentativi di assist",
          "Conversions": "Trasformazioni",
          "Carries": "Carry",
          "Clean breaks": "Break netti",
          "Penalty goals": "Gol su rigore",
          "Drop goals": "Drop goal",
          "Scrums": "Mischie",
          "Lineouts": "Touche",
          "Turnovers": "Palle perse",
          "Turnovers won": "Cambi di possesso vinti",
          "Meters run": "Metri corsi",
          "Offloads": "Scarichi",
          "Tackles": "Placcaggi",
          "Tackles missed": "Placcaggi mancati",
          "Penalties conceded": "Rigori concessi",
          "Red cards": "Cartellini rossi",
          "Yellow cards": "Cartellini gialli"
        },
        "player": {
          "PTS": "Punti",
          "TRY": "Mete",
          "TKL": "Placcaggi",
          "PG": "Gol su rigore",
          "PAS": "Passaggi",
          "CAR": "Carry",
          "CB": "Break netti",
          "DG": "Drop goal",
          "MR": "Metri corsi",
          "OFF": "Scarichi",
          "TM": "Placcaggi mancati",
          "TA": "Tentativi di assist",
          "TW": "Cambi di possesso vinti"
        }
      }
    },
    positions: {
      goalies: "Portieri",
      skaters: "Giocatori di movimento",
      pitchers: "Lanciatori",
      hitters: "Battitori",
      forwards: "Attaccanti",
      midfielders: "Centrocampisti",
      defenders: "Difensori",
      outfielders: "Esterni",
      players: "Giocatori",
    },
    filters: {
      titles: {
        lineType: "Tipo di linea",
        game: "Partita",
        outcome: "O/U",
        betType: "Tipo di scommessa",
        trendType: "Tipo di trend",
        signals: "Segnali",
        season: "Stagione",
        team: "Squadra",
        minOdds: "Quote minime",
        timeframe: "Periodo",
      },
      plurals: {
        lineType: "Tipi di linea",
        game: "Partite",
        outcome: "Esiti",
        betType: "Tipi di scommessa",
        trendType: "Tipi di trend",
        signals: "Segnali",
        season: "Stagioni",
        team: "Squadre",
      },
      options: {
        game: {
          all: "Tutte le partite",
          byGame: "Per partita",
        },
        team: {
          all: "Tutte le squadre",
        },
        lineType: {
          main: "Linee principali",
          alternate: "Linee alternative",
        },
        outcome: {
          all: "Over+Under",
          over: "Over",
          under: "Under",
          yes: "Sì",
          no: "No",
          cover: "Copertura",
        },
        betType: {
          all: "Tutti i tipi di scommessa",
        },
        minOdds: {
          all: "Tutte le quote",
        },
        timeframe: {
          season: "Stagione",
          playoffs: "Playoff",
          headToHead: "Scontri diretti",
          last5: "Ultime 5",
          last10: "Ultime 10",
          last20: "Ultime 20",
          last30: "Ultime 30",
        },
        splits: {
          all: "Casa+Trasferta",
          home: "Home",
          away: "Trasferta",
        },
        trendType: {
          player: "Giocatore",
          team: "Squadra",
        },
        qualifier: {
          averageStats: "Per partita",
          cumulativeStats: "Totale",
        },
        signals: {
          allSignals: "Tutti i segnali",
          recentForm: "Forma recente",
          headToHead: "Scontri diretti",
          homeAwaySplits: "Split casa/trasferta",
          opponentRank: "Ranking avversario",
          injuryImpact: "Impatto infortuni",
          starter: "Titolare",
          weather: "Meteo",
          startingPitcher: "Lanciatore partente",
        },
      },
    },
    empty: {
      checkBackLater: "Riprova più tardi.",
      pendingOdds: {
        title: "Quote in attesa",
      },
    },
  },
  betTypes: {
    ANYTIME_GOAL_SCORER: "Gol",
    ANYTIME_TOUCHDOWN: "TD in qualsiasi momento",
    ANYTIME_TOUCHDOWN_1Q: "TD nel 1Q in qualsiasi momento",
    ANYTIME_TRY_SCORER: "Marcatore di meta in qualsiasi momento",
    ASSISTS: "Assist",
    ASSISTS_1Q: "Assist 1Q",
    ASSISTS_PLUS_REBOUNDS: "REB+AST",
    BLOCKED_SHOTS: "Tiri bloccati",
    BLOCKS: "Stoppate",
    BOTH_TEAMS_TO_SCORE: "Entrambe le squadre segnano",
    CARDS: "Cartellini",
    CORNERS: "Calci d'angolo squadra",
    DISPOSALS: "Disposals",
    DOUBLE_CHANCE: "Doppia chance",
    DOUBLE_DOUBLE: "Doppia doppia",
    EXTRA_POINTS_MADE: "XP segnati",
    FIELD_GOALS_MADE: "Field goal realizzati",
    GAME_TOTAL: "Totale partita",
    GAME_TOTAL_1H: "Totale partita 1T",
    GAME_TOTAL_1Q: "Totale partita 1Q",
    GAME_TOTAL_2H: "Totale partita 2T",
    GAME_TOTAL_CARDS: "Totale cartellini partita",
    GAME_TOTAL_FIRST_5_INNINGS: "Totale primi 5 inning",
    GOAL_OR_ASSIST: "Gol o assist",
    GOALS: "Gol",
    GOALS_ALLOWED: "Gol subiti",
    HITTER_DOUBLES: "Doppi",
    HITTER_HITS: "Hit",
    HITTER_HITS_PLUS_RUNS_PLUS_RUNS_BATTED_IN: "H+R+RBI",
    HITTER_HOME_RUNS: "HR",
    HITTER_RUNS: "Punti",
    HITTER_RUNS_BATTED_IN: "RBI",
    HITTER_SINGLES: "Singoli",
    HITTER_STOLEN_BASES: "Basi rubate",
    HITTER_TOTAL_BASES: "Basi totali",
    HITTER_TRIPLES: "Tripli",
    INTERCEPTIONS: "Int",
    KICKING_POINTS: "Punti al calcio",
    MARKS: "Mark",
    MONEY_LINE: "Vincente",
    MONEY_LINE_1H: "Vincente 1T",
    MONEY_LINE_1Q: "Vincente 1Q",
    MONEY_LINE_2H: "Vincente 2T",
    MONEY_LINE_FIRST_5_INNINGS: "Vincente primi 5 inning",
    PASSING_ATTEMPTS: "Tentativi di passaggio",
    PASSING_COMPLETIONS: "Passaggi completati",
    PASSING_PLUS_RUSHING_YARDS: "Yard passaggio + corsa",
    PASSING_PLUS_RUSHING_YARDS_1Q: "1Q yard passaggio + corsa",
    PASSING_TOUCHDOWNS: "Touchdown da lancio",
    PASSING_YARDS: "Yard su passaggio",
    PASSING_YARDS_1Q: "1Q yard su passaggio",
    PITCHER_EARNED_RUNS: "Punti guadagnati",
    PITCHER_HITS_ALLOWED: "Hit concessi",
    PITCHER_OUTS: "Out del lanciatore",
    PITCHER_STRIKEOUTS: "Strikeout",
    PITCHER_WALKS_ALLOWED: "Basi ball concesse",
    POINTS: "Punti",
    POINTS_1Q: "Punti 1Q",
    POINTS_PLUS_ASSISTS: "PTS+AST",
    POINTS_PLUS_ASSISTS_PLUS_REBOUNDS: "PTS+AST+REB",
    POINTS_PLUS_REBOUNDS: "PTS+REB",
    POWERPLAY_POINTS: "Punti power play",
    REBOUNDS: "Rimbalzi",
    REBOUNDS_1Q: "Rimbalzi 1Q",
    RECEIVING_YARDS: "Yard su ricezione",
    RECEIVING_YARDS_1Q: "1Q yard su ricezione",
    RECEPTIONS: "Ricezioni",
    RUN_FIRST_INNING: "Punto nel primo inning",
    RUSHING_ATTEMPTS: "Tentativi di corsa",
    RUSHING_PLUS_RECEIVING_YARDS: "Yard corsa + ricezione",
    RUSHING_PLUS_RECEIVING_YARDS_1Q: "1Q yard corsa + ricezione",
    RUSHING_YARDS: "Yard su corsa",
    RUSHING_YARDS_1Q: "1Q yard su corsa",
    SAVES: "Parate",
    SHOTS: "SHO",
    SHOTS_ON_GOAL: "Tiri in porta",
    SHOTS_ON_TARGET: "Tiri in porta",
    player: {
      SHOTS_ON_TARGET: "Tiri in porta",
    },
    team: {
      SHOTS_ON_TARGET: "Tiri in porta squadra",
    },
    SHUTOUT: "Shutout",
    SPREAD: "Spread",
    SPREAD_1H: "Spread 1T",
    SPREAD_1Q: "Spread 1Q",
    SPREAD_2H: "Spread 2T",
    SPREAD_FIRST_5_INNINGS: "Spread primi 5 inning",
    STEALS: "Palle rubate",
    STEALS_PLUS_BLOCKS: "STL+BLK",
    TACKLES: "Tackle",
    TEAM_TOTAL: "Totale squadra",
    TEAM_TOTAL_1H: "Totale squadra 1T",
    TEAM_TOTAL_1Q: "Totale squadra 1Q",
    TEAM_TOTAL_2H: "Totale squadra 2T",
    TEAM_TOTAL_CARDS: "Totale cartellini squadra",
    THREE_POINTS_MADE: "3PTM",
    TRIES: "Mete",
    TRIPLE_DOUBLE: "Tripla doppia",
    TURNOVERS: "Palle perse",
    WIN_TO_NIL: "Vincere senza subire",
  },
};
